export const IndustryIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="3"
                y="7"
                width="18"
                height="13"
                rx="2"
                stroke={activeColor}
                strokeWidth="2"
            />

            <path
                d="M9 7V5C9 3.9 9.9 3 11 3H13C14.1 3 15 3.9 15 5V7"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />

            <path
                d="M3 12H21"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}